import { observer } from 'mobx-react';
import React, { useMemo } from 'react';
import { FunctionComponent } from 'react';
import { TempHourAvailability, TimeSlotAvailability } from '../types';
import TrashIcon from '~/asset/calendar/hours/trash.svg';
import { Text } from '~/component/text';
import { Grid, IconButton } from '@mui/material';
import { TimePicker } from 'antd';
import dayjs from 'dayjs';
import { getDisableStartTimes, getDisableEndTimes } from './helpers';

const styles = {
  iconButton: {
    width: 32,
    height: 32,
    padding: 4,
  },
  icon: {
    fontSize: 20,
    width: 20,
    height: 20,
  },
};

const pickerPopupStyle = {
  zIndex: 1500,
};

export const TimeSelectRow: FunctionComponent<{
  index: number;
  from: TimeSlotAvailability;
  to: TimeSlotAvailability;
  onDelete: (hourIndex: number) => void;
  handleUpdateHour: (hourIndex: number, data: TempHourAvailability) => void;
  hasError?: boolean;
}> = observer((props) => {
  const { from, to, index, handleUpdateHour, onDelete, hasError } = props;

  const handleChangeFrom = (value: any) => {
    handleUpdateHour(index, {
      from: {
        hour: value.hour(),
        minute: value.minute(),
      },
      to,
    });
  };
  const handleChangeTo = (value: any) => {
    handleUpdateHour(index, {
      from,
      to: {
        hour: value.hour(),
        minute: value.minute(),
      },
    });
  };
  const fromValue = useMemo(
    () =>
      from.hour !== null && from.minute !== null
        ? dayjs(`${from.hour}:${from.minute}`, 'HH:mm')
        : undefined,
    [from],
  );
  const toValue = useMemo(
    () =>
      to.hour !== null && to.minute !== null
        ? dayjs(`${to.hour}:${to.minute}`, 'HH:mm')
        : undefined,
    [to],
  );

  return (
    <Grid
      container
      flexDirection={'row'}
      justifyContent={'space-between'}
      alignItems={'center'}
      flexWrap={'nowrap'}
      sx={{ height: 42 }}
    >
      <TimePicker
        placeholder="時間選択"
        minuteStep={5}
        hourStep={1}
        format={'HH:mm'}
        showNow={false}
        needConfirm
        allowClear={false}
        suffixIcon={null}
        className="timepicker"
        style={{ maxWidth: 100 }}
        value={fromValue}
        onChange={handleChangeFrom}
        status={hasError ? 'error' : ''}
        disabledTime={() => getDisableStartTimes(to)}
        popupStyle={pickerPopupStyle}
      />
      <Text
        text={`—`}
        className="color--green font--14 fontWeight--400 ml8 mr8"
      />
      <TimePicker
        placeholder="時間選択"
        minuteStep={5}
        hourStep={1}
        format={'HH:mm'}
        showNow={false}
        needConfirm
        allowClear={false}
        suffixIcon={null}
        className="timepicker"
        style={{ maxWidth: 100 }}
        value={toValue}
        onChange={handleChangeTo}
        status={hasError ? 'error' : ''}
        disabledTime={() => getDisableEndTimes(from)}
        popupStyle={pickerPopupStyle}
      />
      <IconButton
        style={styles.iconButton}
        onClick={() => onDelete(index)}
        className="ml4"
      >
        <img style={styles.icon} src={TrashIcon} />
      </IconButton>
    </Grid>
  );
});
